import _ from 'lodash';
import api from '@/api';
import base64toPDF from '../../lib/base64ToPDF';
import Cookies from '@/portal-cookie';
import { message } from 'antd';

const calculateCCFees = import.meta.env.VITE_USE_CC_FEES === 'true';

const AUTH_NET_RESPONSE_SUCCESS = 'true';
const AUTH_NET_RESPONSE_FAIL = 'false';
const SAP_WRITE_SUCCESS = 'true';
const SAP_WRITE_FAIL = 'false';
console.log('calculateCCFees');
console.log(calculateCCFees);

const initialState = {
	invoices: [],
	paymentErrors: [], // errors from authorize.net when attemping to capture payment
	invoicePaymentTotal: 0,
	cardPaymentFeesTotal: 0,
	processingPayment: false,
	processingSuccess: false,
	processingErrors: [], // errors occured when writing to SAP w/ IncomingPayment doc
	successfulTransactionId: '', // this comes from authorize.net
	cardCode: '',
	cardType: '',
	cardName: '',
	loading: false,
	loaded: false,
	loadedVendorCode: false,
	awaitingAcceptToken: false,
	acceptHostedToken: null,
	allowPaymentIframe: true,
	paymentTypeSelected: false,
	showInvoicePaymentDialog: false,
	showPreviewPDFDialog: false,
	showContactDialog: false,
	pdfModalLoading: false,
	pdfModalData: null,
	pdfFilePreview: null,
	pdfModalKey: null,
	totalInvoiceDue: 0.0,
	totalCredit: null,
	customerProfileId: null, // not being used anywhere yet
	customerProfileId_from_SAP: null,
	storePayment: true, // V1 WAS false
	responseCode: null
};

export const types = {
	SET_STATE: 'INVOICE/SET_STATE',
	SET_SELECTED: 'INVOICE/SET_SELECTED',
	UNSET_SELECTED: 'INVOICE/UNSET_SELECTED',
	SET_SELECTED_ALL: 'INVOICE/SET_SELECTED_ALL',
	UNSET_SELECTED_ALL: 'INVOICE/UNSET_SELECTED_ALL',
	SET_PAY_AMOUNT: 'INVOICE/SET_PAY_AMOUNT',
};

const reducers = (state = initialState, action) => {
	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };

		case types.SET_SELECTED:
			return {
				...state,
				// invoices: [
				// 	...state.invoices,
				// 	action.data,
				// ],
				invoices: state.invoices.map((inv) => {
					if (inv.DocNum === action.data.DocNum) {
						return { ...inv, ...action.data };
					}
					return inv;
				}),

			};
		case types.UNSET_SELECTED:
			return {
				...state,
				// invoices: state.invoices
				// 	.filter((record) => record.DocNum !== action.data.DocNum)
				// 	.map((record) => ({ ...record })),
				invoices: state.invoices.map((inv) => {
					if (inv.DocNum === action.data.DocNum) {
						return { ...inv, ...action.data };
					}
					return inv;
				}),

			};
		case types.SET_SELECTED_ALL:
			return {
				...state,
				invoices: state.invoices.map(invoice => ({
					...invoice,
					Checked: (invoice.DocumentStatus == 'Open'
						&& !invoice.isPending) // NOTE the query probably wont return Open documents, but this will prevent select all on recorded
						? true
						: false, // TODO_SELECT_ALL 

					payAmount: (invoice.DocumentStatus == 'Open'
						&& !invoice.isPending) // NOTE the query probably wont return Open documents, but this will prevent amount calc on recorded
						? invoice.AmountDue // TODO ENV
						: 0
				})),
			};
		case types.UNSET_SELECTED_ALL:
			return {
				...state,
				invoices: state.invoices.map(invoice => ({
					...invoice,
					Checked: false
				})),
			};

		case types.SET_PAY_AMOUNT:
			return {
				...state,
				invoices:
					state.invoices.map((inv) => {
						if (inv.DocNum === action.data.DocNum) {
							return { ...inv, ...action.data };
						}
						return inv;
					})
				,
			};

		default:
			return state;
	}
};

export default reducers;

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	resetContactDialog: () => ({
		type: types.SET_STATE, data: {
			showContactDialog: false,
		},
	}),

	resetInvoicePaymentDialog: () => ({
		type: types.SET_STATE, data: {
			showInvoicePaymentDialog: false,
			invoicePaymentTotal: 0,
			cardPaymentFeesTotal: 0,
			processingPayment: false,
			processingSuccess: false,
			processingErrors: [],
			successfulTransactionId: '',
			awaitingAcceptToken: false,
			acceptHostedToken: null,
		},
	}),

	resetInvoicePDFDialog: () => ({
		type: types.SET_STATE, data: {
			showInvoicePDFDialog: false,
		},
	}),

	reset: () => ({ type: types.SET_STATE, data: { ...initialState } }),

	setSelected: (record) => ({ type: types.SET_SELECTED, data: record }),

	unsetSelected: (record) => ({ type: types.UNSET_SELECTED, data: record }),

	setSelectAll: () => ({ type: types.SET_SELECTED_ALL, data: null }),

	unsetSelectAll: () => ({ type: types.UNSET_SELECTED_ALL, data: null }),

	setPayAmount: (record) => ({ type: types.SET_PAY_AMOUNT, data: record }),

	loadInvoices: () => async (dispatch, getState) => {
		console.log('[Invoices.redux] loadInvoices');
		const state = getState(),
			loading = state.invoices.loading,
			cardCode = state.invoices.cardCode,
			cardType = state.invoices.cardType;

		//console.log(cardCode)
		//console.log(cardType)
		if (loading) {
			return false;
		}

		dispatch(actions.setState({ loading: true, loaded: false }));

		try {
			// QUERY: Portal.OpenARInvoicebyCustomer + Portal.TotalOpenARInvoicebyCustomer + Portal.TotalCreditOpenARInvoicebyCustomer
			let response = await api.get('/invoices', {
				params: {
					cardCode,
					cardType
				},
			});

			const _invoices = response[0];
			//console.log(_invoices)

			const totalInvoiceDue = response[1][0]['DocTotalOpen'];
			// console.log(totalInvoiceDue)
			// console.log(typeof totalInvoiceDue)
			const totalCredit = response[2][0]['DocTotalCredit'];
			// const invoices = response.map((invoice) => {
			// 	return { ...invoice, 'PayAmount': invoice.DocumentTotal };
			// });

			const cardNameProp = cardType === 'C' ? 'CustomerName' : 'VendorName';

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					invoices: _invoices,
					cardName: response[0].length > 0
						? response[0][0][cardNameProp]
						: '',
					totalInvoiceDue: totalInvoiceDue,
					totalCredit: totalCredit,
					allowPaymentIframe: true,
					paymentTypeSelected: false
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loaded: true,
					invoices: [],
					cardName: '',
				},
			});
		}
	},

	loadVendorCode: () => async (dispatch) => {
		console.log('[Invoices.redux] loadVendorCode')
		try {
			const userKey = Cookies.get('TS_UserKey', '');
			const response = await api.get('/invoices/vendor-code', {
				params: {
					userKey: userKey,
				},
			});

			// console.log('CustomerProfileId');
			// console.log(response.CustomerProfileId);

			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: response.BPCode,
					cardType: response.BPType,
					customerProfileId_from_SAP: response.CustomerProfileId,
				},
			});
		} catch (err) {
			console.error(err);
			dispatch({
				type: types.SET_STATE,
				data: {
					loading: false,
					loadedVendorCode: true,
					cardCode: '',
					cardType: '',
				},
			});
		}
	},

	loadInvoicePreview: (docEntry, objType, docNum) => async (dispatch) => {
		console.log('[invoices.redux] loadInvoicePreview  docEntry: ' + docEntry);
		dispatch(actions.setState({ pdfModalLoading: true }));
		try {
			const response = await api.get('/invoices/preview', {
				params: {
					docEntry,
					objType
				}
			});

			let fileData = response.FileData;
			let pdf = base64toPDF(fileData);

			dispatch(actions.setState({ pdfModalKey: docEntry }));
			dispatch(actions.setState({ pdfModalDocNum: docNum }));
			dispatch(actions.setState({ pdfModalData: fileData }));
			dispatch(actions.setState({ pdfFilePreview: pdf }));
			dispatch(actions.setState({ pdfModalLoading: false }));
		} catch (e) {
			console.error(e);
			message.error('Could not load invoice preview');
			dispatch(actions.setState({ pdfModalLoading: false }));
		}
	},

	processPayment: (paymentForm) => async (dispatch, getState) => {
		console.log('[Invoices.redux] processPayment')
		// should send invoice keys, query and confirm totals match
		const state = getState(),
			cardCode = state.invoices.cardCode,
			cardName = state.invoices.cardName,
			storePayment = state.invoices.storePayment,
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum),
			invoicePaymentTotal = state.invoices.invoicePaymentTotal,
			cardPaymentFeesTotal = state.invoices.cardPaymentFeesTotal;


		console.log(paymentForm)
		//   console.log(invoices.invoices);

		dispatch(actions.setState({ processingPayment: true }));
		try {

			let paymentResults = await api.post('/payments/capture', {
				paymentForm,
				invoicePaymentTotal,
				cardPaymentFeesTotal,
				cardCode,
				cardName,
				storePayment,
				invoiceDocNums
			});

			console.log('paymentResults');
			console.log(paymentResults);

			// DUMMY {
			// 	"successful": true,
			// 	"paymentData": {
			// 		"paymentType": "CC",
			// 		"paymentContact": "Allen David",
			// 		"paymentAcctType": "Visa",
			// 		"transactionId": "120041836101",
			// 		"paymentTotal": "51.45"
			// 	}
			// }

			if (paymentResults.successful) {
				console.log('paymentResults successful');
				// set pending payment cookie
				let pendingCookie = Cookies.get('pendingInvoices'),
					currentPending = null;
				if (pendingCookie) {
					currentPending = JSON.parse(decodeURIComponent(Cookies.get('pendingInvoices')));
				}

				if (currentPending) {
					const newPending = _.union(currentPending, invoiceDocNums);
					Cookies.set('pendingInvoices', JSON.stringify(newPending));
				} else {
					Cookies.set('pendingInvoices', JSON.stringify(invoiceDocNums));
				}

				dispatch(actions.setState({ responseCode: paymentResults.responseCode }));

				// need to make sure all info is sent, the final payment res does not have a lot
				dispatch(actions.recordPaymentToSAP(paymentResults.paymentData));

				// check if customer Profile is saved, store in state, and record to SAP
				if (paymentResults.customerProfileId) {
					dispatch(actions.setState({ customerProfileId: paymentResults.customerProfileId }));
					dispatch(actions.recordCustomerProfileIdToSAP(paymentResults.customerProfileId));
				}
			} else {
				console.log('paymentResults NOT successful');
				console.log('paymentResults.responseCode');
				console.log(paymentResults.responseCode);
				dispatch(actions.setState({ responseCode: paymentResults.responseCode }));
			}
		} catch (e) {
			//console.error('it done went wrong', e);
			message.error(e.response.data.errors);
			dispatch(actions.setState({
				processingPayment: false,
				processingSuccess: false,
				paymentErrors: [...e.response.data.errors],
			}));
		}
	},

	getAcceptToken_V2: (payType) => async (dispatch, getState) => {
		console.log('[Invoices.redux] getAcceptToken_V2');

		const state = getState(),
			cardCode = state.invoices.cardCode,
			cardName = state.invoices.cardName,
			storePayment = state.invoices.storePayment,
			invoicePaymentTotal = state.invoices.invoicePaymentTotal,
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum),
			customerProfileId_from_SAP = state.invoices.customerProfileId_from_SAP,
			cardPaymentFeesTotal = state.invoices.cardPaymentFeesTotal;

		//console.log('[Invoices.redux] getAcceptToken_V2  invoicePaymentTotal ', invoicePaymentTotal);
		console.log('[Invoices.redux] getAcceptToken_V2  cardPaymentFeesTotal ', cardPaymentFeesTotal);
		console.log('[Invoices.redux] getAcceptToken_V2  cardPaymentFeesTotal typeof', typeof cardPaymentFeesTotal);

		try {

			dispatch(actions.setState({
				acceptHostedToken: null,
				awaitingAcceptToken: true,
			}));


			let _total = invoicePaymentTotal;
			let _fees = cardPaymentFeesTotal;

			// const _totalDue = invoices.filter((invoice) => invoice.Checked).reduce((accumulator, inv) => accumulator + inv.AmountDue, 0);
			// const _partialDue = invoices.filter((invoice) => invoice.Checked).reduce((accumulator, inv) => accumulator + inv.payAmount, 0);
			// console.log(_totalDue + ' / ' + _partialDue);
			// let _isPartialPayment = _partialDue < _totalDue;
			// console.log('isPartialPayment' + isPartialPayment)

			let _customerEmail = Cookies.get('TS_email');

			const _response = await api.get('/payments/get-accept-token', {
				params: {
					paymentType: payType,
					storePayment: storePayment,
					customerProfileId: customerProfileId_from_SAP,
					invoiceDocNums: invoiceDocNums,
					customerEmail: _customerEmail ?? "development@tiger-sheep.com", // TODO_EMAIL, will authorize consume this and do something with it while we also send customerProfileId?
					invoicePaymentTotal: _total,
					cardPaymentFeesTotal: _fees,
					//isPartialPayment: _isPartialPayment,
					cardCode: cardCode,
					cardName: cardName
				}
			});
			//console.log(_response.response);
			//console.log(_response.response.token);
			if (_response.response.token) { // -OR- _response.response.messages.resultCode = 'Ok'
				console.log('[Invoices.redux] getAcceptToken_V2  successful');
				dispatch(actions.setState({
					acceptHostedToken: _response.response.token,
					awaitingAcceptToken: false,
					cardPaymentFeesTotal: _fees,
				}));
			} else {
				console.log('[Invoices.redux] getAcceptToken_V2  unsuccessful ELSE');
				dispatch(actions.setState({
					acceptHostedToken: null,
					awaitingAcceptToken: false,
					cardPaymentFeesTotal: _fees,
				}));
			}

		} catch (err) {
			console.error('[Invoices.redux] getAcceptToken_V2 catch err');
			console.error(err);
			message.error('Could not fetch Authorize.Net token');
			dispatch(actions.setState({
				acceptHostedToken: null,
				awaitingAcceptToken: false,
			}));
		}
	},
	processPayment_V2: (authorizePaymentResponse) => async (dispatch, getState) => {
		console.log('[Invoices.redux] processPayment_V2');
		console.log(authorizePaymentResponse);
		console.log(authorizePaymentResponse.responseCode);
		const state = getState(),
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum);

		// authorizePaymentResponse.accountType Visa / eCheck
		if (authorizePaymentResponse.responseCode == '1') {
			message.success('Your payment has processed successfully and has been recorded');
			dispatch(actions.setState({
				processingPayment: false,
				processingSuccess: true,
				responseCode: authorizePaymentResponse.responseCode,
				successfulTransactionId: authorizePaymentResponse.transId,
			}));

			dispatch(actions.recordPaymentToSAP_V2(authorizePaymentResponse, invoiceDocNums));
		} else {
			console.error('[Invoices.redux] processPayment_V2 BAD ')
		}

	},
	showError_V2: (authorizePaymentResponse) => async (dispatch, getState) => {
		console.log('[Invoices.redux] showError_V2');
		console.log(authorizePaymentResponse);

		const state = getState(),
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum);

		// 1 -- Approved
		// 2 -- Declined
		// 3 -- Error
		// 4 -- Held for Review
		if (authorizePaymentResponse.responseCode == '2') {
			message.error('Your payment was declined');
		} else if (authorizePaymentResponse.responseCode == '3') {
			message.error('Your payment had an error');
		} else if (authorizePaymentResponse.responseCode == '4') {
			message.error('Your payment was held');
		}
		dispatch(actions.recordPaymentToSAP_V2(authorizePaymentResponse, invoiceDocNums));
		dispatch(actions.setState({
			processingPayment: false,
			processingSuccess: false,
		}));

	},
	recordPaymentToSAP: (paymentData) => async (dispatch, getState) => {

		console.log('[Invoices.redux] recordPaymentToSAP');
		console.log(paymentData);

		const state = getState(),
			invoices = state.invoices.invoices,
			cardCode = state.invoices.cardCode,
			creditCardFees = state.invoices.cardPaymentFeesTotal,
			selectedInvoices = invoices.filter((invoice) => invoice.Checked),
			responseCode = state.invoices.responseCode,
			invoiceDocNums = selectedInvoices.map(invoice => invoice.DocNum) || [];


		// console.log('invoiceDocNums');
		// console.log(invoiceDocNums);
		console.log('responseCode');
		console.log(responseCode);

		let paymentResult;
		try {

			// write to sidetable before any SAP interaction
			const loggingResult = await api.post('/invoices/log-transaction', {
				params: {
					invoiceDocNums,
					cardCode,
					creditCardFees,
					responseCode,
				}
			});
			console.log('loggingResult');
			console.log(loggingResult);
			//console.log(loggingResult.sqlResults); // probably too technical to be useful, but might be

			if (Boolean(paymentData.paymentType === 'CC')) {
				// QUERY: Invoices.CheckForCCFee
				// const invoiceCheckResults = await api.get('/invoices/audit', {
				// 	params: {
				// 		invoiceDocNums,
				// 	},
				// });

				// console.log('invoiceCheckResults');
				// console.log(invoiceCheckResults);

				// // GAMGAM we likely wont have invoicesLeftToCreate from staging table situation
				// if (invoiceCheckResults.invoicesLeftToCreate.length > 0) {
				// 	const invoiceData = {
				// 		invoiceDocNums: invoiceCheckResults.invoicesLeftToCreate.join(', '),
				// 		cardCode,
				// 		LineItem: {
				// 			Item: 'CC Fee',
				// 			Qty: 1,
				// 			LineTotal: parseFloat(creditCardFees).toFixed(2)
				// 		},
				// 	};

				// 	const invoiceResult = await api.post('/invoices/create', {
				// 		params: {
				// 			invoiceData
				// 		}
				// 	});

				// 	console.log('invoiceResult');
				// 	console.log(invoiceResult);

				// 	if (invoiceResult.successful) {
				// 		selectedInvoices.push({
				// 			DocEntry: invoiceResult.feeInvoiceKey,
				// 			DocumentTotal: parseFloat(creditCardFees).toFixed(2),
				// 			ObjType: '13'  // CC Fee treated as regular invoice
				// 		});
				// 	} else {
				// 		console.error(`Could not create CC Fee invoice for invoice(s) with doc nums: ${invoiceCheckResults.invoicesLeftToCreate.join(', ')}`);
				// 	}
				// } else {
				// 	console.log('NO invoicesLeftToCreate, proceeding to making payments')
				// }

				// creates IncomingPayment Document
				paymentResult = await api.post('/invoices/payment', {
					params: {
						transaction: paymentData,
						invoiceDocNums: selectedInvoices,
						cardCode,
					}
				});

				console.log('paymentResult CC');
				console.log(paymentResult);
				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be

			} else {
				// creates IncomingPayment Document
				console.log('ELSE creates IncomingPayment Document')
				paymentResult = await api.post('/invoices/payment', {
					params: {
						transaction: paymentData,
						invoiceDocNums: selectedInvoices,
						cardCode,
					}
				});

				console.log('paymentResult');
				console.log(paymentResult);
				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be
			}

			if (paymentResult.successful) {
				// remove any doc nums that were in pending invoices and reset the cookie
				let pendingCookie = Cookies.get('pendingInvoices'),
					pendingInvoices = null;

				if (pendingCookie) {
					pendingInvoices = JSON.parse(decodeURIComponent(Cookies.get('pendingInvoices')));
				}

				if (pendingInvoices) {
					const newPendingInvoices = pendingInvoices.filter(invoice => !invoiceDocNums.includes(invoice));
					Cookies.set('pendingInvoices', JSON.stringify(newPendingInvoices));
				}

				message.success('Your payment has processed successfully and has been recorded');

				dispatch(actions.setState({
					processingPayment: false,
					processingSuccess: true,
					successfulTransactionId: paymentResult.transactionId,
				}));
			} else {

				console.log('paymentResult NOT successful');
				message.error('Your payment was processed but there was an issue recording into SAP. will be marked as Pending.');
			}

		} catch (e) {
			console.log('recordPaymentToSAP catch err');
			console.error(e)
			// console.error(e.response);
			console.error(e.response.data);
			console.error(e.response.data.errors);
			message.error('Your payment has processed but there was an issue updating the invoice. Please do not pay again.');
			dispatch(actions.setState({
				processingPayment: false,
				processingSuccess: false, // BUG2
				processingErrors: ['There was an issue recording your payment. Please do not pay again. Your payment is pending. ', e.response.data.errors]
			}));
		}
	},
	recordPaymentToSAP_V2: (paymentData, invoiceDocNums) => async (dispatch, getState) => {

		console.log('[Invoices.redux] recordPaymentToSAP_V2');
		console.log(paymentData);

		const state = getState(),
			invoices = state.invoices.invoices,
			cardCode = state.invoices.cardCode,
			creditCardFees = state.invoices.cardPaymentFeesTotal,
			selectedInvoices = invoices.filter((invoice) => invoice.Checked),
			responseCode = state.invoices.responseCode;

		console.log('invoiceDocNums', invoiceDocNums);
		console.log('selectedInvoices', selectedInvoices);
		console.log('responseCode', responseCode);
		console.log('creditCardFees', creditCardFees)
		console.log('creditCardFees typeof', typeof creditCardFees) // NaN

		let paymentResult;
		try {

			// write to sidetable before any SAP interaction
			const loggingResult = await api.post('/invoices/log-transaction', {
				params: {
					invoiceDocNums,
					cardCode,
					creditCardFees,
					responseCode,
				}
			});
			console.log('loggingResult');
			console.log(loggingResult);
			//console.log(loggingResult.sqlResults); // probably too technical to be useful, but might be

			console.log('paymentData.accountType')
			console.log(paymentData.accountType)

			// REF https://developer.authorize.net/api/reference/index.html#accept-suite-create-an-accept-payment-transaction
			// REF accountType: Visa, Mastercard, Discover, AmericanExpress, DinersClub, JCB, or eCheck.
			let CC_TYPES = ['Visa', 'MasterCard', 'Mastercard', 'Discover', 'AmericanExpress',
				//'DinersClub', 'JCB', 'eCheck'
			];


			// if credit card fees are supposed to be calculated, and the payment is a credit card, then check if there are any invoices that need to be created for the CC Fee
			if (calculateCCFees && CC_TYPES.includes(paymentData.accountType)) {
				console.log('auditing for CC Fee invoices...')
				// QUERY: Invoices.CheckForCCFee
				// returns invoicesLeftToCreate if they do not appear in the results
				// NOTE the query has a hardcoded ItemCode of 'CC Fee'
				const invoiceCheckResults = await api.get('/invoices/audit', {
					params: {
						invoiceDocNums,
					},
				});

				console.log('invoiceCheckResults');
				console.log(invoiceCheckResults);



				// if there are invoices that need to be created for the CC Fee, then create them before making the payment
				if (invoiceCheckResults.invoicesLeftToCreate.length > 0) {

					let _lineTotal = Number(Number(creditCardFees ?? 0).toFixed(2));
					console.log('_lineTotal', _lineTotal);

					const invoiceData = {
						invoiceDocNums: invoiceCheckResults.invoicesLeftToCreate.join(', '),
						cardCode,
						LineItem: {
							Item: 'CC Fee', // hardcoded
							Qty: 1,
							LineTotal: _lineTotal
						},
					};

					const invoiceResult = await api.post('/invoices/create', {
						params: {
							invoiceData,
							selectedInvoices, // TODO may eventually need to get the U_GS_OrderType to attach to the invoice
						}
					});

					console.log('invoiceResult');
					console.log(invoiceResult);

					// GAMGAM we likely wont have invoicesLeftToCreate (array of docNums) from staging table situation
					if (invoiceResult.successful) {
						console.log('IMPORTANT, adding newly created CC Fee invoice to selectedInvoices'); 
						selectedInvoices.push({
							DocEntry: invoiceResult.invoiceUUID, // U_TS_Fingerprint
							DocumentTotal: _lineTotal,
							ObjType: '13'  // CC Fee treated as regular invoice
						});
					} else {
						console.error(`Could not create CC Fee invoice for invoice(s) with doc nums: ${invoiceCheckResults.invoicesLeftToCreate.join(', ')}`);
					}
				} else {
					console.log('NO invoicesLeftToCreate, proceeding to making payments')
				}

				// creates IncomingPayment Document
				paymentResult = await api.post('/invoices/payment-v2', {
					params: {
						transaction: paymentData,
						creditCardFees,
						invoiceDocNums: invoiceDocNums,
						selectedInvoices: selectedInvoices, // will contain invoiceUUID
						cardCode,
					}
				});

				console.log('paymentResult CC');
				console.log(paymentResult);
				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be

			} else {
				// creates IncomingPayment Document
				console.log('ELSE creates IncomingPayment Document')
				paymentResult = await api.post('/invoices/payment-v2', {
					params: {
						transaction: paymentData,
						invoiceDocNums: invoiceDocNums,
						selectedInvoices: selectedInvoices,
						cardCode,
					}
				});

				console.log('paymentResult');
				console.log(paymentResult);
				// {
				// 	"successful": true,
				// 	"transactionId": "120057050123"
				// }

				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be
			}

			if (paymentResult.successful) {
				//console.log('paymentResult successful - remove any doc nums that were in pending invoices and reset the cookie');
				// remove any doc nums that were in pending invoices and reset the cookie
				let pendingCookie = Cookies.get('pendingInvoices'),
					pendingInvoices = null;

				if (pendingCookie) {
					pendingInvoices = JSON.parse(decodeURIComponent(Cookies.get('pendingInvoices')));
				}

				if (pendingInvoices) {
					const newPendingInvoices = pendingInvoices.filter(invoice => !invoiceDocNums.includes(invoice));
					Cookies.set('pendingInvoices', JSON.stringify(newPendingInvoices));
				}

				//message.success(' ');

				dispatch(actions.setState({
					processingPayment: false,
					processingSuccess: true,
					successfulTransactionId: paymentResult.transactionId, // NOTE the actual payload is called transId, but kept this name in frontend
				}));
			} else {

				//console.log('paymentResult NOT successful');
				// GAMGAM / DONT write to sidetable that there was an issue writing to SAP
				//message.error('Your payment was processed but there was an issue recording into SAP. will be marked as Pending.');

				// const sapWriteFailLogResult = await api.post('/invoices/log-sap-failure', {
				// 	params: {
				// 		invoiceDocNums,
				// 		failedReasons: paymentResult
				// 	}
				// });
				// console.log('sapWriteFailLogResult');
				// console.log(sapWriteFailLogResult);
				// //console.log(sapWriteFailLogResult.sqlResults); // probably too technical to be useful, but might be
			}

		} catch (e) {
			console.log('recordPaymentToSAP_V2 catch err');
			console.error(e)
			// console.error(e.response);
			console.error(e.response.data);
			console.error(e.response.data.errors);

			// GAMGAM / DONT write to sidetable that there was an issue writing to SAP
			// const sapWriteFailLogResult = await api.post('/invoices/log-sap-failure', {
			// 	params: {
			// 		invoiceDocNums,
			// 		failedReasons: e.response.data.errors
			// 	}
			// });
			// console.log('sapWriteFailLogResult');
			// console.log(sapWriteFailLogResult);
			//console.log(sapWriteFailLogResult.sqlResults); // probably too technical to be useful, but might be

			// DONT SHOW THE USER message.error('Your payment has processed but there was an issue updating the invoice. Please do not pay again.');
			dispatch(actions.setState({
				processingPayment: false,
				//processingSuccess: false, // BUG2
				//processingErrors: ['There was an issue recording your payment. Please do not pay again. Your payment is pending. ', e.response.data.errors]
			}));
		}
	},
	// getCustomerProfileIdFromSAP: (cardCode) => async (dispatch, getState) => {

	// 	//const state				= getState();
	// 	//const cardCodeFromState			= state.invoices.cardCode;

	// 	try {
	// 		const response = await api.get('/invoices/customer-profile-id', {
	// 			params: {
	// 				cardCode, // OR cardCodeFromState
	// 			}
	// 		});
	// 		console.log(response)
	// 		if (response.successful) {
	// 			console.log('Customer Profile id stored in SAP is: TODO ');
	// 		}

	// 	} catch (e) {
	// 		console.error(e);
	// 		message.error('Could not save Customer Profile id to Authorize.net.');

	// 	}
	// },

	recordCustomerProfileIdToSAP: (customerProfileId) => async (dispatch, getState) => {
		const state = getState(),
			cardCode = state.invoices.cardCode;

		try {
			const response = await api.post('/invoices/customer-profile-id', {
				params: {
					cardCode,
					customerProfileId,
				}
			});
			if (response.successful) {
				console.log('Customer Profile id ', customerProfileId, ' is Saved to SAP.');
			}

		} catch (e) {
			console.error(e);
			message.error('Could not save Customer Profile id to Authorize.net.');

		}
	},

	processPayment_GAM: (authorizePaymentResponse) => async (dispatch, getState) => {
		console.log('[Invoices.redux] processPayment_GAM');
		console.log(authorizePaymentResponse);
		console.log(authorizePaymentResponse.responseCode);
		const state = getState(),
			invoices = state.invoices.invoices,
			invoiceDocNums = invoices.filter((invoice) => invoice.Checked).map(invoice => invoice.DocNum);

		// authorizePaymentResponse.accountType Visa / eCheck
		if (authorizePaymentResponse.responseCode == '1') {
			message.success('Your payment has processed successfully and has been recorded');
			dispatch(actions.setState({
				processingPayment: false,
				processingSuccess: true,
				responseCode: authorizePaymentResponse.responseCode,
				successfulTransactionId: authorizePaymentResponse.transId,
			}));

			dispatch(actions.recordPaymentToSAP_GAM(authorizePaymentResponse, invoiceDocNums));
		} else {
			console.error('[Invoices.redux] processPayment_GAM BAD ')
		}

	},
	recordPaymentToSAP_GAM: (paymentData, invoiceDocNums) => async (dispatch, getState) => {

		console.log('[Invoices.redux] recordPaymentToSAP_GAM');
		console.log(paymentData);

		const state = getState(),
			invoices = state.invoices.invoices,
			cardCode = state.invoices.cardCode,
			creditCardFees = state.invoices.cardPaymentFeesTotal,
			selectedInvoices = invoices.filter((invoice) => invoice.Checked),
			responseCode = state.invoices.responseCode;

		console.log('invoiceDocNums', invoiceDocNums);
		console.log('selectedInvoices', selectedInvoices);
		console.log('responseCode', responseCode);

		let paymentResult;
		try {

			// write to sidetable before any SAP interaction
			const loggingResult = await api.post('/invoices/log-transaction', {
				params: {
					invoiceDocNums,
					cardCode,
					creditCardFees,
					responseCode,
				}
			});
			console.log('loggingResult');
			console.log(loggingResult);
			//console.log(loggingResult.sqlResults); // probably too technical to be useful, but might be

			console.log('paymentData.accountType')
			console.log(paymentData.accountType)

			// REF https://developer.authorize.net/api/reference/index.html#accept-suite-create-an-accept-payment-transaction
			// REF accountType: Visa, Mastercard, Discover, AmericanExpress, DinersClub, JCB, or eCheck.
			let CC_TYPES = ['Visa', 'MasterCard', 'Mastercard', 'Discover', 'AmericanExpress',
				//'DinersClub', 'JCB', 'eCheck'
			];


			// if credit card fees are supposed to be calculated, and the payment is a credit card, then check if there are any invoices that need to be created for the CC Fee
			if (calculateCCFees && CC_TYPES.includes(paymentData.accountType)) {

				// create invoices for the CC Fee before making the payment
				// no audit, like other implementations have

				let _lineTotal = Number(Number(creditCardFees ?? 0).toFixed(2));
				console.log('_lineTotal', _lineTotal);

				const invoiceData = {
					invoiceDocNums: invoiceDocNums,
					cardCode,
					LineItem: {
						Item: 'CC Fee', // hardcoded
						Qty: 1,
						LineTotal: _lineTotal
					},
				};

				const invoiceResult = await api.post('/invoices/create', {
					params: {
						invoiceData,
						selectedInvoices,
					}
				});

				console.log('invoiceResult');
				console.log(invoiceResult);


				// GAMGAM we likely wont have invoicesLeftToCreate from staging table situation
				if (invoiceResult.successful) {
					console.log('IMPORTANT, adding newly created CC Fee invoice to selectedInvoices'); 
					selectedInvoices.push({
						DocEntry: invoiceResult.invoiceUUID, // U_TS_Fingerprint
						DocumentTotal: _lineTotal,
						ObjType: '13'  // CC Fee treated as regular invoice
					});
				} else {
					console.error(`Could not create CC Fee invoice for invoice(s) with doc nums: ${invoiceDocNums.join(', ')}`);
				}


				// creates IncomingPayment Document
				paymentResult = await api.post('/invoices/payment-v2', {
					params: {
						transaction: paymentData,
						creditCardFees: _lineTotal,
						invoiceDocNums: invoiceDocNums,
						selectedInvoices: selectedInvoices, // will contain invoiceUUID
						cardCode,
					}
				});

				console.log('paymentResult CC');
				console.log(paymentResult);
				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be




			} else {
				// if not needing a CC Fee invoice, just create the payment

				// creates IncomingPayment Document
				console.log('ELSE creates IncomingPayment Document')
				paymentResult = await api.post('/invoices/payment-v2', {
					params: {
						transaction: paymentData,
						invoiceDocNums: invoiceDocNums,
						selectedInvoices: selectedInvoices,
						cardCode,
					}
				});

				console.log('paymentResult');
				console.log(paymentResult);
				// {
				// 	"successful": true,
				// 	"transactionId": "120057050123"
				// }

				//console.log(paymentResult.sqlResults); // probably too technical to be useful, but might be
			}

			if (paymentResult.successful) {
				//console.log('paymentResult successful - remove any doc nums that were in pending invoices and reset the cookie');
				// remove any doc nums that were in pending invoices and reset the cookie
				let pendingCookie = Cookies.get('pendingInvoices'),
					pendingInvoices = null;

				if (pendingCookie) {
					pendingInvoices = JSON.parse(decodeURIComponent(Cookies.get('pendingInvoices')));
				}

				if (pendingInvoices) {
					const newPendingInvoices = pendingInvoices.filter(invoice => !invoiceDocNums.includes(invoice));
					Cookies.set('pendingInvoices', JSON.stringify(newPendingInvoices));
				}

				//message.success(' ');

				dispatch(actions.setState({
					processingPayment: false,
					processingSuccess: true,
					successfulTransactionId: paymentResult.transactionId, // NOTE the actual payload is called transId, but kept this name in frontend
				}));
			} else {

				//console.log('paymentResult NOT successful');
				// GAMGAM / DONT write to sidetable that there was an issue writing to SAP
				//message.error('Your payment was processed but there was an issue recording into SAP. will be marked as Pending.');

				// const sapWriteFailLogResult = await api.post('/invoices/log-sap-failure', {
				// 	params: {
				// 		invoiceDocNums,
				// 		failedReasons: paymentResult
				// 	}
				// });
				// console.log('sapWriteFailLogResult');
				// console.log(sapWriteFailLogResult);
				// //console.log(sapWriteFailLogResult.sqlResults); // probably too technical to be useful, but might be
			}

		} catch (e) {
			console.log('recordPaymentToSAP_GAM catch err');
			console.error(e)
			// console.error(e.response);
			console.error(e.response.data);
			console.error(e.response.data.errors);

			// GAMGAM / DONT write to sidetable that there was an issue writing to SAP
			// const sapWriteFailLogResult = await api.post('/invoices/log-sap-failure', {
			// 	params: {
			// 		invoiceDocNums,
			// 		failedReasons: e.response.data.errors
			// 	}
			// });
			// console.log('sapWriteFailLogResult');
			// console.log(sapWriteFailLogResult);
			//console.log(sapWriteFailLogResult.sqlResults); // probably too technical to be useful, but might be

			// DONT SHOW THE USER message.error('Your payment has processed but there was an issue updating the invoice. Please do not pay again.');
			dispatch(actions.setState({
				processingPayment: false,
				//processingSuccess: false, // BUG2
				//processingErrors: ['There was an issue recording your payment. Please do not pay again. Your payment is pending. ', e.response.data.errors]
			}));
		}
	},

};
